module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6lu"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres6luIndex,
      "searchBoxAlias": "approve",
      "maxRowspan": _vm.maxRowspan.index,
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.postHres6luSendApprove
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "labels": _vm.labels[_vm.dash.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.dtereq,
      "currentNumseq": _vm.currentNumseq,
      "currentCodempid": _vm.codempid,
      "tab2Table": _vm.columns[_vm.dash.nowLang].detailTab2,
      "tab3Table": _vm.columns[_vm.dash.nowLang].detailTab3,
      "toggle": _vm.toggle,
      "indexSelected": _vm.indexSelected,
      "nowLang": _vm.dash.nowLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b7c0764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6lu/component.vue
// module id = 3741
// module chunks = 1